import { inject, Injectable } from '@angular/core';

import { SignalREventModel, SignalRService } from '@gan/core/util-signalr';

import { SIGNAL_R_PROPERTIES } from '../properties';

import { AuthService } from '@gan/common/feature-auth';
import { BusReplacementInterface } from '@gan/common/data-bus-replacements';

/**
 * signal R service for bus replacements
 */
@Injectable()
export class BusReplacementsSignalRService extends SignalRService<SignalREventModel<BusReplacementInterface>[]> {
  private authService = inject(AuthService);

  // The API sends the changes as "replacements" to everyone connected, for every train
  hubMethod = SIGNAL_R_PROPERTIES.method;

  /**
   * start signalR bus replacements hub connection
   */
  override startHubConnection(hubName = SIGNAL_R_PROPERTIES.busReplacementsHub) {
    return super.startHubConnection(hubName, this.authService.signalRConnectionOptions);
  }
}
